<div class="!pr-[40px] !mb-[60px] flex">
  <div class="!w-[90%]">
    <div class="h-auto">
      <div class="container flex !pt-[15px]">
        <h3 class="!text-[20px] !text-[#000000] !font-bold !pl-[20px]">
          LIST OF SUBMISSIONS
        </h3>
      </div>
    </div>

    <app-filter-tool></app-filter-tool>

    <table class="w-full bg-[#fcfcfd] table-auto !mt-[20px]">
      <thead
        class="h-[52px] bg-[#DEE2E6] text-[#000000] !text-center justify-center !p-[20px]"
      >
        <tr>
          <th class="px-4 text-left w-[160px] header-field">EOI No.</th>
          <th class="px-4 text-left w-auto header-field">Title</th>
          <th
            class="px-4 text-left w-auto header-field"
            style="text-align: center"
          >
            Issued
          </th>
          <th
            class="px-4 text-left w-auto header-field"
            style="text-align: center"
          >
            Received
          </th>
          <th
            class="px-4 text-left w-auto header-field"
            style="text-align: center"
          >
            Pending
          </th>
          <th class="px-4 text-center w-auto header-field">Action</th>
        </tr>
      </thead>
      <tbody class="!text-center" *ngIf="tableData[0]">
        <ng-container *ngFor="let eoiList of tableData; let i = index">
          <tr
            class="hover:bg-[#fae8e1] border-b-0"
            [ngClass]="{ 'bg-white': i % 2 === 0, 'bg-[#DEE2E6]': i % 2 !== 0 }"
          >
            <td
              class="border-b-0 pr-4 pl-[1rem] py-2 w-auto cursor-pointer text-left whitespace-nowrap"
              (click)="openView(eoiList?.id)"
            >
              {{ this.projectIdentifier }}  {{ eoiList?.code }}
            </td>
            <td class="border-b-0 px-4 py-2 w-auto cursor-pointer text-left">
              {{ eoiList?.name }}
            </td>
            <td
              class="border-b-0 px-4 py-2 w-auto cursor-pointer text-left"
              style="text-align: center"
            >
              {{ eoiList?.total }}
            </td>
            <td
              class="border-b-0 px-4 py-2 w-auto text-left"
              style="text-align: center"
            >
              {{ eoiList?.total_submitted }}
            </td>
            <td
              class="border-b-0 px-4 py-2 w-auto text-left"
              style="text-align: center"
            >
              {{ eoiList?.total_pending }}
            </td>
            <!-- DropDown Menu -->
            <td class="border-b-0 px-4 py-2 w-auto cursor-pointer text-center">
              <button mat-button [matMenuTriggerFor]="menu">
                <mat-icon class="text-[#000000]">more_vert</mat-icon>
              </button>
              <mat-menu #menu="matMenu">
                <button
                  mat-menu-item
                  (click)="resumeEOIDialogue(eoiList?.id)"
                  [disabled]="eoiList?.is_initiated === 1"
                >
                  <mat-icon style="color: #2196f3; font-size: 24px !important"
                    >edit</mat-icon
                  >
                  <span style="margin-left: 10px">Edit</span>
                </button>
                <button mat-menu-item (click)="confirmationDialog(eoiList?.id)">
                  <div class="flex" style="display: flex; align-items: center">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="27"
                      height="27"
                      viewBox="0 0 27 27"
                      fill="none"
                    >
                      <path
                        d="M21.3454 10.5372C20.9567 10.5372 20.6622 10.7194 20.4395 10.984C20.4327 10.9012 20.4287 10.8296 20.4287 10.7726C20.4287 9.56117 19.7594 8.77817 18.7233 8.77817C18.2654 8.77817 17.9151 8.90579 17.6545 9.08609C17.4979 8.54508 17.0384 7.94428 16.1584 7.94428C15.6732 7.94428 15.3007 8.0893 15.0236 8.27245C15.0123 6.85943 15.0013 5.43281 15.0013 5.32544C15.0013 4.82636 14.4026 3.85547 13.3053 3.85547C12.362 3.85547 11.8353 4.74114 11.6729 5.26422C11.6602 5.30547 11.653 5.34822 11.6515 5.39136L11.4229 12.2859C11.0231 11.5316 10.451 10.8098 10.0205 10.5899C9.52137 10.3343 8.67736 10.508 8.17638 10.9666C7.71258 11.3904 7.59114 11.993 7.84305 12.6197C8.04365 13.1178 8.16536 13.7036 8.30611 14.3816C8.48599 15.2466 8.70963 16.3234 9.18588 17.6361C9.95005 19.7454 12.3363 21.973 13.0016 22.5658V24.1516C13.0016 25.7214 14.2807 26.9983 15.853 26.9983H18.9759C20.5483 26.9983 21.8276 25.7199 21.8276 24.1487V22.2442C22.6294 21.1443 23.1085 19.1648 23.1292 19.0777C23.1379 19.041 23.1424 19.0033 23.1424 18.9657V12.3781C23.1424 11.2769 22.4204 10.5372 21.3454 10.5372Z"
                        fill="#E76B3F"
                      />
                      <path
                        d="M22.1782 18.9083C22.028 19.5133 21.5586 21.0582 20.9721 21.7757C20.9018 21.8619 20.8634 21.9697 20.8634 22.0809V24.1493C20.8634 25.1889 20.0168 26.0345 18.976 26.0345H15.8531C14.8126 26.0345 13.966 25.1903 13.966 24.1521V22.3474C13.966 22.2776 13.9509 22.2087 13.9216 22.1453C13.8924 22.082 13.8497 22.0258 13.7965 21.9806C13.7676 21.9557 10.8778 19.4748 10.0924 17.308C9.63993 16.0602 9.433 15.0644 9.25054 14.1858C9.10009 13.4626 8.97042 12.8383 8.7378 12.2606C8.61235 11.9484 8.70906 11.7958 8.80747 11.6974C8.99815 11.5067 9.30823 11.4356 9.48052 11.4356C9.52502 11.4356 9.56057 11.4403 9.58224 11.4493C9.90735 11.6155 10.6974 12.7361 10.902 13.5464C10.9853 13.8755 11.0273 14.1882 11.0642 14.4641C11.1351 14.991 11.1909 15.4067 11.5064 15.6577C11.5763 15.7132 11.6604 15.7482 11.7491 15.7588C11.8378 15.7693 11.9277 15.755 12.0088 15.7175C12.0898 15.6801 12.1589 15.6208 12.2082 15.5464C12.2576 15.472 12.2853 15.3853 12.2882 15.2961L12.6128 5.50022C12.6785 5.33447 12.9144 4.82031 13.3054 4.82031C13.8645 4.82031 14.039 5.34296 14.0371 5.32646C14.0371 5.55248 14.0825 11.1451 14.0825 11.1451C14.0835 11.2678 14.1312 11.3855 14.2159 11.4742C14.3007 11.5629 14.416 11.6159 14.5385 11.6225C14.7947 11.6503 15.0136 11.4502 15.0435 11.1974L15.2577 9.3724C15.3425 9.24246 15.6135 8.90907 16.1584 8.90907C16.6453 8.90907 16.7359 9.31212 16.7564 9.51926L17.0589 11.4756C17.0978 11.7266 17.3285 11.9069 17.578 11.8824C17.7 11.8716 17.8133 11.8148 17.8948 11.7235C17.9764 11.6322 18.0202 11.5133 18.0173 11.3909L17.9876 10.1394C18.0394 10.0146 18.2113 9.74291 18.7233 9.74291C19.3359 9.74291 19.4644 10.3032 19.4644 10.7731C19.4644 11.357 19.7439 12.8646 19.7757 13.0346C19.8197 13.2705 20.0295 13.4475 20.2705 13.4272C20.3865 13.4222 20.4967 13.3755 20.581 13.2958C20.6653 13.2161 20.7179 13.1086 20.7294 12.9931C20.7963 12.3179 21.086 11.502 21.3455 11.502C22.0336 11.502 22.1782 11.979 22.1782 12.3787L22.1782 18.9083Z"
                        fill="#E9E7D1"
                      />
                      <path
                        d="M10.6069 3.375C10.6069 1.51421 9.09293 0 7.23193 0C5.37094 0 3.85693 1.51421 3.85693 3.375C3.85693 5.23579 5.37094 6.75 7.23193 6.75C9.09293 6.75 10.6069 5.23579 10.6069 3.375Z"
                        fill="#E76B3F"
                      />
                      <path
                        d="M7.23199 5.78624C5.90282 5.78624 4.82129 4.70471 4.82129 3.37554C4.82129 2.04637 5.90282 0.964844 7.23199 0.964844C8.56116 0.964844 9.64269 2.04637 9.64269 3.37554C9.64269 4.70471 8.56116 5.78624 7.23199 5.78624Z"
                        fill="#EAEAEA"
                      />
                      <path
                        d="M7.23205 1.44531C7.16873 1.44529 7.10602 1.45775 7.04751 1.48197C6.98901 1.50619 6.93585 1.54171 6.89107 1.58648C6.84629 1.63126 6.81078 1.68442 6.78656 1.74293C6.76233 1.80143 6.74988 1.86414 6.7499 1.92746V3.17426L5.92687 3.99729C5.8821 4.04205 5.84658 4.09519 5.82235 4.15368C5.79812 4.21216 5.78564 4.27485 5.78564 4.33816C5.78564 4.40147 5.79812 4.46416 5.82235 4.52265C5.84658 4.58114 5.8821 4.63428 5.92687 4.67904C5.97158 4.72388 6.02471 4.75945 6.08321 4.78369C6.14171 4.80794 6.20442 4.82038 6.26775 4.82031C6.33107 4.82039 6.39379 4.80795 6.45229 4.7837C6.51079 4.75946 6.56392 4.72389 6.60862 4.67904L7.57292 3.71474C7.61771 3.66998 7.65324 3.61685 7.67748 3.55836C7.70172 3.49987 7.7142 3.43717 7.7142 3.37386V1.92741C7.71421 1.86409 7.70175 1.80139 7.67752 1.74289C7.6533 1.68439 7.61778 1.63124 7.57301 1.58647C7.52823 1.5417 7.47507 1.50619 7.41657 1.48197C7.35807 1.45775 7.29537 1.44529 7.23205 1.44531Z"
                        fill="#E76B3F"
                      />
                    </svg>
                    <span style="margin-left: 10px">Close</span>
                  </div>
                </button>
                <button mat-menu-item (click)="openView(eoiList?.id)">
                  <mat-icon style="color: #4caf50; font-size: 24px !important"
                    >visibility</mat-icon
                  >
                  <span style="margin-left: 10px">View Details</span>
                </button>
              </mat-menu>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>

  <div class="ml-auto flex !mt-[20px]">
    <button
      (click)="handleCreateEoi()"
      class="!bg-[#E76B3F] !text-[#ffffff] !text-[14px] flex h-[38px] w-[120px] items-center flex-shrink-0 hover:bg-white rounded-[3px] shadow-md ml-[15px] text-center"
      style="padding: 14px 10px; font-weight: 700"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <g clip-path="url(#clip0_5810_47932)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12 0C5.38125 0 0 5.38125 0 12C0 18.6187 5.38125 24 12 24C18.6187 24 24 18.6187 24 12C24 5.38125 18.6187 0 12 0Z"
            fill="#E76B3F"
          />
          <path
            d="M5.4375 13.107V10.8898C5.4375 10.6648 5.62031 10.4773 5.85 10.4773H10.4859V5.84609C10.4859 5.62109 10.6687 5.43359 10.8984 5.43359H13.1156C13.3406 5.43359 13.5234 5.61641 13.5234 5.84609V10.482H18.1547C18.3797 10.482 18.5672 10.6648 18.5672 10.8945V13.1117C18.5672 13.3367 18.3844 13.5195 18.1547 13.5195H13.5187V18.1508C13.5187 18.3758 13.3359 18.5633 13.1109 18.5633H10.8937C10.6687 18.5633 10.4813 18.3805 10.4813 18.1508V13.5148H5.85C5.62031 13.5195 5.4375 13.332 5.4375 13.107Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_5810_47932">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
      Create EOI
    </button>
  </div>
</div>

<!-- TODO: error on this -->
<ng-container *ngIf="isCreate">
  <app-wrapper
    (handleDialog)="handleDialog()"
    [currentDialog]="currentDialog"
    [currentEOISavedData]="savedEOIData"
  ></app-wrapper>
</ng-container>
